import clsx from "clsx";
import { Button } from "../common";
import { Link } from "react-router-dom";
import { LuCalendarDays } from "react-icons/lu";
import { useEffect, useRef, useState } from "react";
import { formatPrice } from "../../utils/formatPrice";
import { useMapStore } from "../../stores/mapCordinations";
import type { ListingDetailed } from "../../interfaces/listing";
import { convertToFormattedAmount } from "../../utils/convertAmount";

interface GreatDealProps {
  listing: ListingDetailed | null;
}

const GreatDeal = ({ listing }: GreatDealProps) => {
  const [showCalendar, setShowCalendar] = useState(false);
  const calendarRef = useRef<HTMLDivElement | null>(null);

  const { showProperty, handleNavigate } = useMapStore();

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        calendarRef.current &&
        !calendarRef.current.contains(event.target as Node)
      ) {
        setShowCalendar(false);
      }
    };

    if (showCalendar) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showCalendar]);

  return (
    <div>
      <div
        className={clsx(
          "flex flex-col sticky",
          showProperty || handleNavigate ? "top-24" : "top-6"
        )}
      >
        <div className="bg-z-prussian-blue px-5 py-6 rounded-[20px] flex flex-col divide-y-[1px] divide-[#B3B3B3]">
          <div className="flex text-white justify-between pb-5 flex-col">
            <div className="text-sm">List Price</div>
            <span className="text-[32px] font-bold">
              {listing?.listPrice
                ? `$${formatPrice(
                    convertToFormattedAmount(listing?.listPrice)
                  )}`
                : "N/A"}
            </span>
          </div>
          <div>
            <div className="pt-5 text-2xl font-bold text-white">
              Down payment boost <br /> breakdown
            </div>
            <div className="space-y-4 mt-4">
              <div className="flex justify-between items-center text-z-shark bg-white rounded-full p-3">
                <div className="font-medium text-sm">
                  Min. down payment needed
                </div>
                <div className="font-bold">
                  {listing?.minDownPaymentNeeded
                    ? `${formatPrice(
                        convertToFormattedAmount(listing?.minDownPaymentNeeded)
                      )}`
                    : "N/A"}
                </div>
              </div>
              <div className="flex justify-between items-center text-z-shark bg-z-abbey rounded-full p-3">
                <div className="font-medium text-sm">Zown's contribution</div>
                <div className="font-bold">
                  {listing?.downPaymentContribution
                    ? `$${formatPrice(
                        convertToFormattedAmount(
                          listing?.downPaymentContribution
                        )
                      )}`
                    : "N/A"}
                </div>
              </div>
              <div className="flex justify-between items-center text-z-shark bg-white rounded-full p-3">
                <div className="font-medium text-sm">
                  New down payment needed
                </div>
                <div className="font-bold">
                  {listing?.newDownPaymentNeeded
                    ? `$${formatPrice(
                        convertToFormattedAmount(listing?.newDownPaymentNeeded)
                      )}`
                    : "N/A"}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="rounded-[20px] relative top-0 bg-z-abbey flex flex-col justify-center items-center py-6 space-y-3 mt-3">
          <div className="text-2xl font-bold">Interested in this home?</div>
          <Link
            target="_blank"
            to="https://calendly.com/d/cmww-xkc-9gs/zown-property-information-meeting"
          >
            <Button
              width="240px"
              radius="50px"
              customClassName="!bg-white h-11 space-x-3"
            >
              <span className="text-z-shark font-bold">Contact Us</span>
              <LuCalendarDays className="text-z-shark text-lg" />
            </Button>
          </Link>
          {showCalendar && (
            <div
              ref={calendarRef}
              className="w-[350px] !mt-0 h-auto p-6 rounded-[20px] absolute top-1/2 -translate-y-1/2 -left-[360px] z-10"
              style={{
                background:
                  "linear-gradient(180deg, #FECD07 0%, #FFBE55 100%), linear-gradient(97deg, #4B8238 0.19%, #10583A 100%)",
              }}
            >
              <div className="text-center mb-5 text-z-shark text-2xl font-bold">
                Select a date
              </div>
              {/* <Calendar
								singleSelect
								setButtonEnabled={setButtonEnabled}
								dates={dates}
								setDates={setDates}
							/> */}
              <Button
                radius="50px"
                onClick={() => {
                  setShowCalendar(false);
                }}
                customClassName="h-11 mt-3"
                variant="dark"
                width="full"
              >
                <span className="font-bold mr-3">Book Showing</span>
                <LuCalendarDays className="text-2xl" />
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export { GreatDeal };
